module.exports = __webpack_public_path__ + "media/assets/images/blog/agile-introduction-small-53d5ea928e1b07283aac3d88f3e7dba6.png";